import React, { useState, useEffect } from 'react';
import Breadcrumbs from '../../src/components/Breadcrumbs';
import Swal from 'sweetalert2';

const SummonsProcess = () => {

  // useEffect(() => {
  //   Swal.fire({
  //       icon: "warning",
  //       title: "Reminder to all users",
  //       text: "Please only use live data when interacting with this page.",
  //       confirmButtonColor: '#A5CC2D', 
  //     });
  // }, []);
  
  const [activeTab, setActiveTab] = useState('upload');
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ message: '', isSuccess: false, show: false });
  const [historyStatus, setHistoryStatus] = useState({ message: '', isSuccess: false, show: false });
  const [responseData, setResponseData] = useState(null);
  const [uploadedCsvData, setUploadedCsvData] = useState(null);
  const [historyData, setHistoryData] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [debtIdFilter, setDebtIdFilter] = useState('');
  const [resultFilter, setResultFilter] = useState('All');
  const [legalNegotiatorFilter, setLegalNegotiatorFilter] = useState('All');
  const [legalResolutionStatusFilter, setLegalResolutionStatusFilter] = useState('All');
  const [poaTypeFilter, setPoaTypeFilter] = useState('All');
  
  // Enhanced validation and editing states
  const [validationErrors, setValidationErrors] = useState({});
  const [editedData, setEditedData] = useState({});
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  
  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  
  // Column order state
  const [uploadColumnOrder, setUploadColumnOrder] = useState([
    'debt_id', 'has_summons', 'poa_sent_date', 'summons_date', 'service_date',
    'legal_negotiator', 'legal_resolution_status', 'poa_type', 'prelegal', 'requested_loan_amount'
    //'sif_auth', 'sif_letter', 'notes' // Commented 
  ]);
  
  const [historyColumnOrder, setHistoryColumnOrder] = useState([
    'debt_id', 'has_summons', 'poa_sent_date', 'summons_date', 'service_date',
    'legal_negotiator', 'legal_resolution_status', 'poa_type', 'prelegal', 'requested_loan_amount',
    'date', 'time', 'success'
  ]);
  
  const [draggedColumn, setDraggedColumn] = useState(null);

  // Reset pagination when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [debtIdFilter, resultFilter, legalNegotiatorFilter, legalResolutionStatusFilter, poaTypeFilter]);

  // Set default dates
  useEffect(() => {
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const lastMonthStr = lastMonth.toISOString().split('T')[0];
    setStartDate(lastMonthStr);
    setEndDate(todayStr);
  }, []);

  // Column definitions
  const uploadColumnDefinitions = {
    debt_id: { name: 'Debt ID', width: '80px' },
    has_summons: { name: 'Has Summons', width: '100px' },
    poa_sent_date: { name: 'POA Sent Date', width: '120px' },
    summons_date: { name: 'Summons Date', width: '120px' },
    service_date: { name: 'Service Date', width: '120px' },
    legal_negotiator: { name: 'Legal Negotiator', width: '130px' },
    legal_resolution_status: { name: 'Legal Resolution Status', width: '150px' },
    poa_type: { name: 'POA Type', width: '100px' },
    prelegal: { name: 'Prelegal', width: '100px' },
    requested_loan_amount: { name: 'Requested Loan Amount', width: '150px' }
    // sif_auth: { name: 'SIF Auth', width: '100px' },
    // sif_letter: { name: 'SIF Letter', width: '100px' },
    // notes: { name: 'Notes', width: '150px' }
  };

  const historyColumnDefinitions = {
    ...uploadColumnDefinitions,
    date: { name: 'Date', width: '100px' },
    time: { name: 'Time', width: '80px' },
    success: { name: 'Result', width: '80px' }
  };

  // Drag handlers
  const handleDragStart = (e, columnKey) => {
    setDraggedColumn(columnKey);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, targetColumnKey, isUploadTable = false) => {
    e.preventDefault();
    
    if (!draggedColumn || draggedColumn === targetColumnKey) {
      setDraggedColumn(null);
      return;
    }

    if (isUploadTable) {
      const newColumnOrder = [...uploadColumnOrder];
      const draggedIndex = newColumnOrder.indexOf(draggedColumn);
      const targetIndex = newColumnOrder.indexOf(targetColumnKey);

      newColumnOrder.splice(draggedIndex, 1);
      newColumnOrder.splice(targetIndex, 0, draggedColumn);
      
      setUploadColumnOrder(newColumnOrder);
    } else {
      const newColumnOrder = [...historyColumnOrder];
      const draggedIndex = newColumnOrder.indexOf(draggedColumn);
      const targetIndex = newColumnOrder.indexOf(targetColumnKey);

      newColumnOrder.splice(draggedIndex, 1);
      newColumnOrder.splice(targetIndex, 0, draggedColumn);
      
      setHistoryColumnOrder(newColumnOrder);
    }
    
    setDraggedColumn(null);
  };

  // Sorting handlers
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    setCurrentPage(1);
  };

  const getSortIcon = (columnKey) => {
    if (sortConfig.key !== columnKey) {
      return ' ↕️';
    }
    return sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
  };

  // Pagination handlers
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const getPageNumbers = (totalPages) => {
    const pageNumbers = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
      const end = Math.min(totalPages, start + maxVisible - 1);
      
      if (start > 1) {
        pageNumbers.push(1);
        if (start > 2) pageNumbers.push('...');
      }
      
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
      
      if (end < totalPages) {
        if (end < totalPages - 1) pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  // Enhanced validation functions
  const validateRow = (row) => {
    const errors = {};
    
    if (!row.debt_id || row.debt_id === '') {
      errors.debt_id = 'Debt ID is required';
    }
    
    if (row.has_summons !== undefined && row.has_summons !== null && row.has_summons !== '') {
      const hasSummonsNum = Number(row.has_summons);
      if (isNaN(hasSummonsNum) || (hasSummonsNum !== 0 && hasSummonsNum !== 1)) {
        errors.has_summons = 'Has Summons must be 0 or 1';
      }
    } else {
      errors.has_summons = 'Has Summons is required';
    }
    
    if (row.poa_sent_date && row.poa_sent_date !== '') {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(row.poa_sent_date)) {
        errors.poa_sent_date = 'Invalid date format (YYYY-MM-DD)';
      } else {
        const date = new Date(row.poa_sent_date);
        if (isNaN(date.getTime())) {
          errors.poa_sent_date = 'Invalid date';
        } else {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (date > today) {
            errors.poa_sent_date = 'POA Sent Date cannot be in the future';
          }
        }
      }
    }
    
    if (row.summons_date && row.summons_date !== '') {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(row.summons_date)) {
        errors.summons_date = 'Invalid date format (YYYY-MM-DD)';
      } else {
        const date = new Date(row.summons_date);
        if (isNaN(date.getTime())) {
          errors.summons_date = 'Invalid date';
        } else {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (date > today) {
            errors.summons_date = 'Summons Date cannot be in the future';
          }
        }
      }
    }
    
    if (row.service_date && row.service_date !== '') {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(row.service_date)) {
        errors.service_date = 'Invalid date format (YYYY-MM-DD)';
      } else {
        const date = new Date(row.service_date);
        if (isNaN(date.getTime())) {
          errors.service_date = 'Invalid date';
        } else {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (date > today) {
            errors.service_date = 'Service Date cannot be in the future';
          }
        }
      }
    }
    
    if (row.prelegal !== undefined && row.prelegal !== null && row.prelegal !== '') {
      const prelegalNum = Number(row.prelegal);
      if (isNaN(prelegalNum) || (prelegalNum !== 0 && prelegalNum !== 1)) {
        errors.prelegal = 'Prelegal must be 0 or 1';
      }
    }
    
    return errors;
  };

  const validateAllRows = (data) => {
    const allErrors = {};
    data.forEach((row, index) => {
      const rowErrors = validateRow(row);
      if (Object.keys(rowErrors).length > 0) {
        allErrors[index] = rowErrors;
      }
    });
    return allErrors;
  };

  const csvToJSON = (csv) => {
    try {
      const lines = csv.split('\n').filter(line => line.trim() !== '');
      if (lines.length < 2) throw new Error('CSV must have at least a header row and one data row');
      
      const result = [];
      const headers = lines[0].split(',').map(header => header.trim().replace(/['"]/g, ''));
      
      const convertToYYYYMMDD = (dateStr) => {
        if (!dateStr || dateStr.trim() === '') return '';
        dateStr = dateStr.trim();
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateStr)) {
          const parts = dateStr.split('/');
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) {
          const parts = dateStr.split('/');
          const month = parts[0].padStart(2, '0');
          const day = parts[1].padStart(2, '0');
          return `${parts[2]}-${month}-${day}`;
        }
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
          const parts = dateStr.split('-');
          return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(dateStr)) {
          const parts = dateStr.split('-');
          const month = parts[0].padStart(2, '0');
          const day = parts[1].padStart(2, '0');
          return `${parts[2]}-${month}-${day}`;
        }
        const date = new Date(dateStr);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        return dateStr;
      };
      
      for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue;
        const obj = {};
        const currentLine = lines[i].split(',');
        
        for (let j = 0; j < headers.length; j++) {
          let value = currentLine[j] ? currentLine[j].trim().replace(/^"|"$/g, '') : '';
          const standardFieldName = getStandardFieldName(headers[j]);
          
          if (standardFieldName === 'poa_sent_date' || 
              standardFieldName === 'summons_date' || 
              standardFieldName === 'service_date') {
            value = convertToYYYYMMDD(value);
          } else {
            if (value.toLowerCase() === 'true') value = true;
            else if (value.toLowerCase() === 'false') value = false;
            else if (!isNaN(value) && value !== '' && !isNaN(parseFloat(value))) value = parseFloat(value);
          }
          
          obj[standardFieldName] = value;
        }
        
        if (obj.has_summons === true) obj.has_summons = 1;
        else if (obj.has_summons === false) obj.has_summons = 0;
        else if (typeof obj.has_summons === 'string' && obj.has_summons.toLowerCase() === 'true') obj.has_summons = 1;
        else if (typeof obj.has_summons === 'string' && obj.has_summons.toLowerCase() === 'false') obj.has_summons = 0;
        
        if (obj.prelegal === true) obj.prelegal = 1;
        else if (obj.prelegal === false) obj.prelegal = 0;
        else if (typeof obj.prelegal === 'string' && obj.prelegal.toLowerCase() === 'yes') obj.prelegal = 1;
        else if (typeof obj.prelegal === 'string' && obj.prelegal.toLowerCase() === 'no') obj.prelegal = 0;
        
        result.push(obj);
      }
      return result;
    } catch (error) {
      throw new Error('Failed to parse CSV file: ' + error.message);
    }
  };

  const getStandardFieldName = (fieldName) => {
    const field = fieldName.toLowerCase().replace(/[^a-z0-9]/g, '_');
    const fieldMap = {
      'debt_id': 'debt_id', 'has_summons': 'has_summons', 'poa_sent_date': 'poa_sent_date',
      'summons_date': 'summons_date', 'service_date': 'service_date', 'legal_negotiator': 'legal_negotiator',
      'legal_resolution_status': 'legal_resolution_status', 'poa_type': 'poa_type',
      'prelegal': 'prelegal', 'pre_legal': 'prelegal', 'requested_loan_amount': 'requested_loan_amount'
      //'sif_auth': 'sif_auth', 'sif_letter': 'sif_letter', 'notes': 'notes' // commented
    };
    return fieldMap[field] || fieldName;
  };

  const formatCurrency = (amount) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    if (parts.length === 3 && parts[0].length === 4) {
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
    return dateString;
  };

  const showStatus = (message, isSuccess, isHistory = false) => {
    if (isHistory) {
      setHistoryStatus({ message, isSuccess, show: true });
      setTimeout(() => setHistoryStatus(prev => ({ ...prev, show: false })), 5000);
    } else {
      setStatus({ message, isSuccess, show: true });
      setTimeout(() => setStatus(prev => ({ ...prev, show: false })), 5000);
    }
  };

  const handleCellEdit = (rowIndex, field, value) => {
    const newEditedData = { ...editedData };
    if (!newEditedData[rowIndex]) newEditedData[rowIndex] = {};
    newEditedData[rowIndex][field] = value;
    setEditedData(newEditedData);

    const currentData = uploadedCsvData[rowIndex];
    const editedRow = { ...currentData, [field]: value };
    const rowErrors = validateRow(editedRow);

    const newValidationErrors = { ...validationErrors };
    if (Object.keys(rowErrors).length > 0) {
      newValidationErrors[rowIndex] = rowErrors;
    } else {
      delete newValidationErrors[rowIndex];
    }
    setValidationErrors(newValidationErrors);
  };

  const getCellValue = (rowIndex, field, originalValue) => {
    if (editedData[rowIndex] && editedData[rowIndex][field] !== undefined) {
      return editedData[rowIndex][field];
    }
    return originalValue;
  };

  const isAllRowsValid = () => Object.keys(validationErrors).length === 0;

  const getValidationSummary = () => {
    const errorCount = Object.keys(validationErrors).length;
    const totalRows = uploadedCsvData ? uploadedCsvData.length : 0;
    
    if (errorCount === 0 && totalRows > 0) {
      return { message: `All ${totalRows} rows are valid and ready for upload`, isValid: true };
    } else if (errorCount > 0) {
      return { message: `${errorCount} row(s) have validation errors that need to be fixed`, isValid: false };
    } else {
      return { message: 'No data to validate', isValid: false };
    }
  };

  const handleFileUpload = async () => {
    if (!file) {
      showStatus('Please select a CSV file', false);
      return;
    }

    try {
      setIsLoading(true);
      const csvText = await file.text();
      const jsonData = csvToJSON(csvText);

      if (jsonData.length === 0) {
        showStatus('CSV file appears to be empty or invalid', false);
        return;
      }

      const currentDate = new Date().toISOString().split('T')[0];
      const enrichedJsonData = jsonData.map(record => ({
        ...record,
        summons_process_date: currentDate
      }));

      setUploadedCsvData(enrichedJsonData);
      const validationErrors = validateAllRows(enrichedJsonData);
      setValidationErrors(validationErrors);
      setIsPreviewMode(true);
      setResponseData(null);

      const errorCount = Object.keys(validationErrors).length;
      if (errorCount > 0) {
        showStatus(`CSV loaded with ${errorCount} validation error(s). Please review and fix errors before uploading.`, false);
      } else {
        showStatus('CSV loaded successfully! All data is valid. Click "Confirm Upload" to proceed.', true);
      }
      setCurrentPage(1);
    } catch (error) {
      showStatus('Error processing file: ' + error.message, false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmUpload = async () => {
    if (!uploadedCsvData || uploadedCsvData.length === 0) {
      showStatus('No data to upload. Please upload a CSV file first.', false);
      return;
    }

    if (!isAllRowsValid()) {
      showStatus('Please fix all validation errors before uploading.', false);
      return;
    }

    try {
      setIsLoading(true);
      const dataToUpload = uploadedCsvData.map((row, index) => {
        if (editedData[index]) return { ...row, ...editedData[index] };
        return row;
      });

      const response = await fetch('https://eoyq2k7ubx65cdf.m.pipedream.net', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dataToUpload)
      });

      const responseText = await response.text();

      if (response.ok) {
        try {
          const responseDataResult = JSON.parse(responseText);
          showStatus('Summons process data uploaded successfully!', true);
          setResponseData({ status: response.status, data: responseDataResult });
        } catch (parseError) {
          showStatus('Summons process data uploaded successfully!', true);
          setResponseData({ 
            status: response.status, 
            data: { summonsRecordUpdates: [], summonsNotes: [], rawResponse: responseText } 
          });
        }
        
        setFile(null);
        setIsPreviewMode(false);
        setValidationErrors({});
        setEditedData({});
        setCurrentPage(1);
      } else {
        showStatus(`Upload failed with status ${response.status}: ${responseText}`, false);
      }
    } catch (error) {
      showStatus('Error uploading data: ' + error.message, false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelPreview = () => {
    setIsPreviewMode(false);
    setValidationErrors({});
    setEditedData({});
    setFile(null);
    setUploadedCsvData(null);
    setCurrentPage(1);
    showStatus('Preview cancelled. You can upload a new file.', true);
  };

  const fetchHistory = async () => {
    if (!startDate || !endDate) {
      showStatus('Please select both start and end dates', false, true);
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(`https://eo4evmkedhccd0e.m.pipedream.net?start_date=${startDate}&end_date=${endDate}`);
      
      if (response.ok) {
        const data = await response.json();
        showStatus('Summons process history retrieved successfully!', true, true);
        setHistoryData(data);
        setCurrentPage(1);
      } else {
        showStatus('Failed to retrieve history. Please try again.', false, true);
      }
    } catch (error) {
      showStatus('Error fetching history: ' + error.message, false, true);
    } finally {
      setIsLoading(false);
    }
  };

  // Render upload table with sorting and pagination
  const renderUploadTable = () => {
    let dataArray = uploadedCsvData ? [...uploadedCsvData] : [];

    if (sortConfig.key && dataArray.length > 0) {
      dataArray = dataArray.sort((a, b) => {
        const aValue = a[sortConfig.key] || '';
        const bValue = b[sortConfig.key] || '';
        
        const numericColumns = ['debt_id', 'requested_loan_amount'];
        if (numericColumns.includes(sortConfig.key)) {
          const aNum = parseFloat(aValue) || 0;
          const bNum = parseFloat(bValue) || 0;
          return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        
        if (aStr < bStr) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aStr > bStr) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    const totalPages = Math.ceil(dataArray.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = dataArray.slice(startIndex, endIndex);

    const validationSummary = isPreviewMode ? getValidationSummary() : null;

    return (
      <div>
        {isPreviewMode && validationSummary && (
          <div style={{
            backgroundColor: validationSummary.isValid ? '#dcfce7' : '#fef2f2',
            border: `1px solid ${validationSummary.isValid ? '#bbf7d0' : '#fecaca'}`,
            borderRadius: '8px', padding: '12px', marginBottom: '12px',
            fontSize: '12px', fontWeight: '500',
            color: validationSummary.isValid ? '#166534' : '#dc2626'
          }}>
            {validationSummary.message}
            {!validationSummary.isValid && (
              <div style={{ marginTop: '4px', fontSize: '11px', fontWeight: 'normal' }}>
                Please fix the highlighted errors in the table below before uploading.
              </div>
            )}
          </div>
        )}

        {dataArray.length > 0 && (
          <div style={{
            backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb',
            padding: '12px', marginBottom: '12px', display: 'flex',
            justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: '500', color: '#374151' }}>Show:</label>
              <select value={itemsPerPage} onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                style={{ border: '1px solid #d1d5db', borderRadius: '4px', padding: '3px 6px',
                  fontSize: '11px', backgroundColor: 'white', cursor: 'pointer', width: '70px' }}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span style={{ fontSize: '12px', color: '#6b7280' }}>entries per page</span>
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>
              Showing {startIndex + 1} to {Math.min(endIndex, dataArray.length)} of {dataArray.length} entries
              {isPreviewMode && <span style={{ marginLeft: '8px', color: '#2563eb' }}>• Preview Mode</span>}
            </div>
            {totalPages > 1 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db',
                    borderRadius: '4px', backgroundColor: currentPage === 1 ? '#f9fafb' : 'white',
                    color: currentPage === 1 ? '#9ca3af' : '#374151',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>
                  Previous
                </button>
                {getPageNumbers(totalPages).map((pageNum, index) => (
                  <button key={index} onClick={() => typeof pageNum === 'number' && handlePageChange(pageNum)}
                    disabled={pageNum === '...'}
                    style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db',
                      borderRadius: '4px', backgroundColor: pageNum === currentPage ? '#2563eb' : 'white',
                      color: pageNum === currentPage ? 'white' : pageNum === '...' ? '#9ca3af' : '#374151',
                      cursor: pageNum === '...' ? 'default' : 'pointer',
                      fontWeight: pageNum === currentPage ? '500' : 'normal' }}>
                    {pageNum}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db',
                    borderRadius: '4px', backgroundColor: currentPage === totalPages ? '#f9fafb' : 'white',
                    color: currentPage === totalPages ? '#9ca3af' : '#374151',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>
                  Next
                </button>
              </div>
            )}
          </div>
        )}

        <div style={{ backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', margin: 0 }}>
              {isPreviewMode ? `Data Preview (${dataArray.length} records)` : `Upload Results (${dataArray.length} records)`}
              {dataArray.length > 0 ? (
                <span style={{ 
                  color: isPreviewMode ? '#2563eb' : '#059669', 
                  fontSize: '12px', 
                  marginLeft: '8px' 
                }}>
                  • {isPreviewMode ? 'Review & Edit' : 'Data Loaded'}
                </span>
              ) : (
                <span style={{ color: '#6b7280', fontSize: '12px', marginLeft: '8px' }}>• No data yet</span>
              )}
            </h2>
          </div>
          
          <div style={{ overflow: 'auto', maxHeight: '60vh', border: '1px solid #e5e7eb' }}>
            <table style={{ minWidth: '100%', fontSize: '12px', color: '#374151' }}>
              <thead style={{ backgroundColor: '#f9fafb', position: 'sticky', top: 0, zIndex: 10, borderBottom: '1px solid #d1d5db' }}>
                <tr>
                  {uploadColumnOrder.map((key, index) => (
                    <th key={key}
                      draggable
                      onDragStart={(e) => handleDragStart(e, key)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, key, true)}
                      onClick={() => handleSort(key)}
                      style={{
                        padding: '8px', textAlign: 'left',
                        borderRight: index < uploadColumnOrder.length - 1 ? '1px solid #d1d5db' : 'none',
                        width: uploadColumnDefinitions[key].width, fontWeight: '600',
                        cursor: 'pointer', userSelect: 'none',
                        backgroundColor: draggedColumn === key ? '#e5e7eb' : '#f9fafb'
                      }}
                      title="Click to sort • Drag to reorder">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>{uploadColumnDefinitions[key].name}</span>
                        <span style={{ fontSize: '10px', opacity: 0.7 }}>{getSortIcon(key)}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataArray.length === 0 ? (
                  <tr>
                    <td colSpan={uploadColumnOrder.length} style={{ 
                      padding: '40px', textAlign: 'center', color: '#6b7280',
                      fontSize: '14px', fontStyle: 'italic'
                    }}>
                      No data uploaded yet. Upload a CSV file to see data here.
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((row, idx) => {
                    const actualIndex = startIndex + idx;
                    const rowErrors = validationErrors[actualIndex] || {};
                    const hasErrors = Object.keys(rowErrors).length > 0;

                    return (
                      <tr key={actualIndex} style={{
                        borderBottom: '1px solid #e5e7eb',
                        backgroundColor: hasErrors ? '#fef2f2' : 'transparent'
                      }}>
                        {uploadColumnOrder.map((key, colIndex) => {
                          const cellValue = getCellValue(actualIndex, key, row[key]);
                          const cellError = rowErrors[key];
                          
                          return (
                            <td key={key} style={{
                              padding: '8px',
                              borderRight: colIndex < uploadColumnOrder.length - 1 ? '1px solid #e5e7eb' : 'none',
                              backgroundColor: cellError ? '#fef2f2' : 'transparent',
                              border: cellError ? '1px solid #fecaca' : 'none',
                              position: 'relative'
                            }}
                            title={cellError ? cellError : ''}>
                              {isPreviewMode ? (
                                <div style={{ position: 'relative' }}>
                                  {key === 'debt_id' && (
                                    <input
                                      type="number" value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {key === 'has_summons' && (
                                    <select
                                      value={cellValue != null ? String(cellValue) : ''} 
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    >
                                      <option value="">Select</option>
                                      <option value="1">TRUE</option>
                                      <option value="0">FALSE</option>
                                    </select>
                                  )}
                                  {(key === 'poa_sent_date' || key === 'summons_date' || key === 'service_date') && (
                                    <input
                                      type="date" value={cellValue || ''}
                                      max={new Date().toISOString().split('T')[0]}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {(key === 'legal_negotiator' || key === 'legal_resolution_status' || key === 'poa_type') && (
                                    <input
                                      type="text" value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {key === 'prelegal' && (
                                    <select
                                      value={cellValue != null ? String(cellValue) : ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    >
                                      <option value="">Select</option>
                                      <option value="0">No</option>
                                      <option value="1">Yes</option>
                                    </select>
                                  )}
                                  {key === 'requested_loan_amount' && (
                                    <input
                                      type="number" step="0.01" min="0.01" value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {/* {(key === 'sif_auth' || key === 'sif_letter') && (
                                    <input
                                      type="text" value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {key === 'notes' && (
                                    <input
                                      type="text" value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%', padding: '2px 4px', fontSize: '11px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px', backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )} */}
                                  {cellError && (
                                    <div style={{ 
                                      position: 'absolute', bottom: '-18px', left: '0',
                                      fontSize: '10px', color: '#dc2626', whiteSpace: 'nowrap',
                                      backgroundColor: 'white', padding: '1px 3px',
                                      borderRadius: '2px', border: '1px solid #fecaca', zIndex: 5
                                    }}>
                                      {cellError}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <>
                                  {key === 'debt_id' && <span style={{ fontWeight: '500' }}>{row.debt_id}</span>}
                                  {key === 'has_summons' && (
                                    <span style={{
                                      padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: '500',
                                      backgroundColor: Number(row.has_summons) === 1 ? '#fef3c7' : '#f3f4f6',
                                      color: Number(row.has_summons) === 1 ? '#92400e' : '#374151'
                                    }}>
                                      {Number(row.has_summons) === 1 ? 'TRUE' : 'FALSE'}
                                    </span>
                                  )}
                                  {(key === 'poa_sent_date' || key === 'summons_date' || key === 'service_date') && 
                                    (row[key] ? formatDate(row[key]) : '')}
                                  {(key === 'legal_negotiator' || key === 'legal_resolution_status' || key === 'poa_type') && 
                                    (row[key] || '')}
                                  {key === 'prelegal' && (
                                    row.prelegal !== undefined && row.prelegal !== null && row.prelegal !== '' ? (
                                      <span style={{
                                        padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: '500',
                                        backgroundColor: Number(row.prelegal) === 1 ? '#d1fae5' : '#f3f4f6',
                                        color: Number(row.prelegal) === 1 ? '#065f46' : '#374151'
                                      }}>
                                        {Number(row.prelegal) === 1 ? 'Yes' : 'No'}
                                      </span>
                                    ) : ''
                                  )}
                                  {key === 'requested_loan_amount' && (row[key] ? formatCurrency(row[key]) : '')}
                                  {/* {(key === 'sif_auth' || key === 'sif_letter') && (row[key] || '')}
                                  {key === 'notes' && (row[key] || '')} */}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  // Render history table with sorting and pagination
  const renderHistoryTable = () => {
    let dataArray = historyData ? [...historyData] : [];

    dataArray = dataArray.filter(record => {
      const resultMatch = resultFilter === 'All' || 
        (resultFilter === 'Success' && record.success) || 
        (resultFilter === 'Failed' && !record.success);
      return resultMatch;
    });

    if (sortConfig.key && dataArray.length > 0) {
      dataArray = dataArray.sort((a, b) => {
        const aValue = a[sortConfig.key] || '';
        const bValue = b[sortConfig.key] || '';
        
        const numericColumns = ['debt_id', 'requested_loan_amount'];
        if (numericColumns.includes(sortConfig.key)) {
          const aNum = parseFloat(aValue) || 0;
          const bNum = parseFloat(bValue) || 0;
          return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        
        if (aStr < bStr) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aStr > bStr) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    const totalPages = Math.ceil(dataArray.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = dataArray.slice(startIndex, endIndex);

    return (
      <div>
        {dataArray.length > 0 && (
          <div style={{
            backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb',
            padding: '12px', marginBottom: '12px', display: 'flex',
            justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: '500', color: '#374151' }}>Show:</label>
              <select value={itemsPerPage} onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                style={{ border: '1px solid #d1d5db', borderRadius: '4px', padding: '3px 6px',
                  fontSize: '11px', backgroundColor: 'white', cursor: 'pointer', width: '70px' }}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span style={{ fontSize: '12px', color: '#6b7280' }}>entries per page</span>
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>
              Showing {startIndex + 1} to {Math.min(endIndex, dataArray.length)} of {dataArray.length} entries
            </div>
            {totalPages > 1 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db',
                    borderRadius: '4px', backgroundColor: currentPage === 1 ? '#f9fafb' : 'white',
                    color: currentPage === 1 ? '#9ca3af' : '#374151',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>
                  Previous
                </button>
                {getPageNumbers(totalPages).map((pageNum, index) => (
                  <button key={index} onClick={() => typeof pageNum === 'number' && handlePageChange(pageNum)}
                    disabled={pageNum === '...'}
                    style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db',
                      borderRadius: '4px', backgroundColor: pageNum === currentPage ? '#2563eb' : 'white',
                      color: pageNum === currentPage ? 'white' : pageNum === '...' ? '#9ca3af' : '#374151',
                      cursor: pageNum === '...' ? 'default' : 'pointer',
                      fontWeight: pageNum === currentPage ? '500' : 'normal' }}>
                    {pageNum}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db',
                    borderRadius: '4px', backgroundColor: currentPage === totalPages ? '#f9fafb' : 'white',
                    color: currentPage === totalPages ? '#9ca3af' : '#374151',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>
                  Next
                </button>
              </div>
            )}
          </div>
        )}

        <div style={{ backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', margin: 0 }}>
              Historical Logs ({dataArray.length} records)
              {historyData && historyData.length > 0 ? (
                <span style={{ color: '#059669', fontSize: '12px', marginLeft: '8px' }}>• Data Loaded</span>
              ) : (
                <span style={{ color: '#6b7280', fontSize: '12px', marginLeft: '8px' }}>• No data yet</span>
              )}
            </h2>
          </div>
          
          <div style={{ overflow: 'auto', maxHeight: '60vh', border: '1px solid #e5e7eb' }}>
            <table style={{ minWidth: '100%', fontSize: '12px', color: '#374151' }}>
              <thead style={{ backgroundColor: '#f9fafb', position: 'sticky', top: 0, zIndex: 10, borderBottom: '1px solid #d1d5db' }}>
                <tr>
                  {historyColumnOrder.map((key, index) => (
                    <th key={key}
                      draggable
                      onDragStart={(e) => handleDragStart(e, key)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, key, false)}
                      onClick={() => handleSort(key)}
                      style={{
                        padding: '8px', textAlign: 'left',
                        borderRight: index < historyColumnOrder.length - 1 ? '1px solid #d1d5db' : 'none',
                        width: historyColumnDefinitions[key].width, fontWeight: '600',
                        cursor: 'pointer', userSelect: 'none',
                        backgroundColor: draggedColumn === key ? '#e5e7eb' : '#f9fafb'
                      }}
                      title="Click to sort • Drag to reorder">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>{historyColumnDefinitions[key].name}</span>
                        <span style={{ fontSize: '10px', opacity: 0.7 }}>{getSortIcon(key)}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataArray.length === 0 ? (
                  <tr>
                    <td colSpan={historyColumnOrder.length} style={{ 
                      padding: '40px', textAlign: 'center', color: '#6b7280',
                      fontSize: '14px', fontStyle: 'italic'
                    }}>
                      No historical data available. Use filters above and click "Get History" to retrieve data.
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((record, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                      {historyColumnOrder.map((key, colIndex) => (
                        <td key={key} style={{
                          padding: '8px',
                          borderRight: colIndex < historyColumnOrder.length - 1 ? '1px solid #e5e7eb' : 'none'
                        }}>
                          {key === 'debt_id' && <span style={{ fontWeight: '500' }}>{record.debt_id}</span>}
                          {key === 'has_summons' && (
                            <span style={{
                              padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: '500',
                              backgroundColor: record.has_summons ? '#fef3c7' : '#f3f4f6',
                              color: record.has_summons ? '#92400e' : '#374151'
                            }}>
                              {record.has_summons ? 'TRUE' : 'FALSE'}
                            </span>
                          )}
                          {(key === 'poa_sent_date' || key === 'summons_date' || key === 'service_date' || key === 'date') && 
                            (record[key] ? formatDate(record[key]) : '')}
                          {key === 'legal_negotiator' && record.legal_negotiator}
                          {key === 'legal_resolution_status' && (
                            <span style={{
                              padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: '500',
                              backgroundColor: record.legal_resolution_status === 'Resolved' ? '#dcfce7' : 
                                              record.legal_resolution_status === 'Pending' ? '#fef3c7' : '#f3f4f6',
                              color: record.legal_resolution_status === 'Resolved' ? '#166534' : 
                                     record.legal_resolution_status === 'Pending' ? '#92400e' : '#374151'
                            }}>
                              {record.legal_resolution_status || 'Unknown'}
                            </span>
                          )}
                          {(key === 'poa_type' || key === 'time') && (record[key] || '')}
                          {key === 'prelegal' && (
                            record.prelegal !== undefined && record.prelegal !== null && record.prelegal !== '' ? (
                              <span style={{
                                padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: '500',
                                backgroundColor: Number(record.prelegal) === 1 ? '#d1fae5' : '#f3f4f6',
                                color: Number(record.prelegal) === 1 ? '#065f46' : '#374151'
                              }}>
                                {Number(record.prelegal) === 1 ? 'Yes' : 'No'}
                              </span>
                            ) : ''
                          )}
                          {key === 'requested_loan_amount' && (record[key] ? formatCurrency(record[key]) : '')}
                          {key === 'success' && (
                            <span style={{
                              padding: '2px 6px', borderRadius: '4px', fontSize: '11px', fontWeight: '500',
                              backgroundColor: record.success ? '#dcfce7' : '#fef2f2',
                              color: record.success ? '#166534' : '#dc2626'
                            }}>
                              {record.success ? 'Success' : 'Failed'}
                            </span>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const selectStyle = {
    border: '1px solid #d1d5db', borderRadius: '4px', padding: '6px 8px',
    fontSize: '11px', backgroundColor: 'white', cursor: 'pointer'
  };

  return (
    <div className="app-container">
      <div className="container">
        <h1>Summon Process</h1>
        {/* <h1>Bulk Update Tool</h1> */}
        <Breadcrumbs />
        
        <div style={{ minHeight: '50vh', backgroundColor: '#f9fafb', borderRadius:'15px'}}> 
          <div style={{ width: '100%', margin: '0 auto' }}>
          
          {/* Tab Navigation */}
          <div style={{
            backgroundColor: 'white', borderRadius: '8px 8px 0 0', border: '1px solid #e5e7eb',
            borderBottom: 'none', display: 'flex'
          }}>
            <button
              onClick={() => setActiveTab('upload')}
              style={{
                padding: '12px 20px', fontSize: '12px', fontWeight: '500', border: 'none',
                borderRight: '1px solid #e5e7eb', borderRadius: '8px 0 0 0',
                backgroundColor: activeTab === 'upload' ? '#2563eb' : '#f9fafb',
                color: activeTab === 'upload' ? 'white' : '#374151', cursor: 'pointer'
              }}
            >
              Upload CSV
            </button>
            <button
              onClick={() => setActiveTab('history')}
              style={{
                padding: '12px 20px', fontSize: '12px', fontWeight: '500', border: 'none',
                backgroundColor: activeTab === 'history' ? '#2563eb' : '#f9fafb',
                color: activeTab === 'history' ? 'white' : '#374151', cursor: 'pointer'
              }}
            >
              Historical Logs
            </button>
          </div>

          {/* Content Area */}
          <div style={{
            backgroundColor: 'white', border: '1px solid #e5e7eb',
            borderRadius: '0 0 8px 8px', padding: '20px'
          }}>
            
            {/* Upload Tab Content */}
            {activeTab === 'upload' && (
              <div>
                {/* Upload Controls */}
                <div style={{ 
                  backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb', 
                  padding: '16px', marginBottom: '20px', display: 'flex', gap: '12px',
                  flexWrap: 'wrap', alignItems: 'end'
                }}>
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: '200px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                      Choose File
                    </label>
                    <input
                      type="file" accept=".csv"
                      onChange={(e) => setFile(e.target.files[0])}
                      disabled={isPreviewMode}
                      style={{
                        ...selectStyle, width: '200px',
                        opacity: isPreviewMode ? 0.6 : 1,
                        cursor: isPreviewMode ? 'not-allowed' : 'pointer'
                      }}
                    />
                  </div>
                  
                  <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                    {!isPreviewMode ? (
                      <button
                        onClick={handleFileUpload}
                        disabled={isLoading || !file}
                        style={{
                          backgroundColor: (isLoading || !file) ? '#9ca3af' : '#2563eb',
                          color: 'white', padding: '8px 16px', borderRadius: '4px',
                          fontSize: '11px', border: 'none', fontWeight: '500',
                          cursor: (isLoading || !file) ? 'not-allowed' : 'pointer'
                        }}
                      >
                        {isLoading ? 'Loading...' : 'Preview CSV'}
                      </button>
                    ) : (
                      <>
                        <button
                          onClick={handleCancelPreview}
                          disabled={isLoading}
                          style={{
                            backgroundColor: '#6b7280', color: 'white', padding: '8px 16px',
                            borderRadius: '4px', fontSize: '11px', border: 'none', fontWeight: '500',
                            cursor: isLoading ? 'not-allowed' : 'pointer'
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleConfirmUpload}
                          disabled={isLoading || !isAllRowsValid()}
                          style={{
                            backgroundColor: (isLoading || !isAllRowsValid()) ? '#9ca3af' : '#059669',
                            color: 'white', padding: '8px 16px', borderRadius: '4px',
                            fontSize: '11px', border: 'none', fontWeight: '500',
                            cursor: (isLoading || !isAllRowsValid()) ? 'not-allowed' : 'pointer'
                          }}
                        >
                          {isLoading ? 'Uploading...' : 'Confirm Upload'}
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* Status Messages */}
                {status.show && (
                  <div style={{
                    padding: '12px', marginBottom: '20px', borderRadius: '8px', fontSize: '12px',
                    backgroundColor: status.isSuccess ? '#dcfce7' : '#fef2f2',
                    color: status.isSuccess ? '#166534' : '#dc2626',
                    border: `1px solid ${status.isSuccess ? '#bbf7d0' : '#fecaca'}`
                  }}>
                    {status.message}
                  </div>
                )}

                {renderUploadTable()}
              </div>
            )}

            {/* History Tab Content */}
            {activeTab === 'history' && (
              <div>
                {/* Filter Controls */}
                <div style={{ 
                  backgroundColor: '#f9fafb', borderRadius: '8px', border: '1px solid #e5e7eb', 
                  padding: '16px', marginBottom: '20px', display: 'flex', gap: '12px',
                  flexWrap: 'wrap', alignItems: 'end'
                }}>
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                      Start Date
                    </label>
                    <input
                      type="date" value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      style={selectStyle}
                    />
                  </div>
                  
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                      End Date
                    </label>
                    <input
                      type="date" value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      style={selectStyle}
                    />
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                    <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                      Result
                    </label>
                    <select 
                      value={resultFilter} 
                      onChange={(e) => setResultFilter(e.target.value)}
                      style={selectStyle}
                    >
                      <option value="All">All</option>
                      <option value="Success">Success</option>
                      <option value="Failed">Failed</option>
                    </select>
                  </div>
                  
                  <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                    <button
                      onClick={fetchHistory}
                      disabled={isLoading || !startDate || !endDate}
                      style={{
                        backgroundColor: (isLoading || !startDate || !endDate) ? '#9ca3af' : '#2563eb',
                        color: 'white', padding: '8px 16px', borderRadius: '4px',
                        fontSize: '11px', border: 'none', fontWeight: '500',
                        cursor: (isLoading || !startDate || !endDate) ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {isLoading ? 'Loading...' : 'Get History'}
                    </button>
                  </div>
                </div>

                {/* History Status */}
                {historyStatus.show && (
                  <div style={{
                    padding: '12px', marginBottom: '20px', borderRadius: '8px', fontSize: '12px',
                    backgroundColor: historyStatus.isSuccess ? '#dcfce7' : '#fef2f2',
                    color: historyStatus.isSuccess ? '#166534' : '#dc2626',
                    border: `1px solid ${historyStatus.isSuccess ? '#bbf7d0' : '#fecaca'}`
                  }}>
                    {historyStatus.message}
                  </div>
                )}

                {renderHistoryTable()}
              </div>
            )}
          </div>

          {/* Footer */}
          <div style={{
            backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb',
            padding: '12px', marginTop: '12px', textAlign: 'center',
            fontSize: '12px', color: '#6b7280'
          }}>
            <div style={{ marginBottom: '4px', fontSize: '11px' }}>
              <strong>Tip:</strong> Click column headers to sort data. Drag headers to reorder columns. Use pagination controls to navigate through all records.
            </div>
            <div style={{ fontSize: '11px', color: '#6b7280' }}>
              <strong>Required Fields:</strong> Debt ID • Has Summons | <strong>Date Format:</strong> DD/MM/YYYY
            </div>
            {isPreviewMode && (
              <div style={{ fontSize: '11px', color: '#2563eb', marginTop: '4px' }}>
                <strong>Preview Mode:</strong> Review and edit data above. Fix highlighted errors before confirming upload.
              </div>
            )}
          </div>
        </div>
        </div>

        <div style={{ marginTop: '50px', textAlign: 'left', fontSize: '1em', color: '#fff' }}>
        © 2025 Pacific Debt Relief. All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default SummonsProcess;